import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import People from "@material-ui/icons/People";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from 'react-redux';
import { compact, filter, find, map, truncate, values } from "lodash";

import Badge from "components/Badge/Badge.jsx";
import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Checkbox from "@material-ui/core/Checkbox";
import Close from "@material-ui/icons/Close";
import ConvidarUsuario from "./partials/ConvidarUsuario";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoIcon from "@material-ui/icons/Info";
import Table from "components/Table/Table.jsx";
import Tooltip from "@material-ui/core/Tooltip";

import { addUserAssinatura, fetchAssinatura, removeUserAssinatura, updateUserAssinatura } from "services/assinatura";
import { showAlert } from "reducers/alerts/actions";

import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import lightTooltipStyle from "assets/EnergyCompany/jss/lightTooltip";

const styles = theme => ({
  ...extendedTablesStyle,
  ...lightTooltipStyle(theme),
});

class Assinatura extends Component {
  state = {
    adminUserChanging: null,
    assinatura: null,
    removingUser: null,
  };

  componentDidMount() {
    fetchAssinatura()
      .then(({ data }) => this.setState({ assinatura : data }));
  }

  getButton = usuario => {
    const { classes } = this.props;
    const { removingUser } = this.state;
    const currentUser = this.getCurrentUser();

    const actionsBtns = [{ color: "danger", icon: Close }];

    return map(actionsBtns, (prop, key) => (
      removingUser === usuario.id ? (
        <BouncingLoader key={key} />
      ) : (
        <Button
          color={prop.color}
          customclass={classes.actionButton}
          disabled={usuario.email === currentUser.email}
          key={key}
          onClick={() => this.handleRemoveUserClick(usuario)}
        >
          <prop.icon className={classes.icon} />
        </Button>
      )
    ));
  }

  getAdminSelect(usuario) {
    return this.state.adminUserChanging === usuario.id ? (
      <BouncingLoader />
    ) : (
      <Checkbox checked={usuario.admin} onChange={e => this.handleIsAdminChange(usuario, e.target.checked)} />
    );
  }

  getCurrentUser() {
    const { assinatura } = this.state;
    const { user } = this.props;

    if (assinatura && user.info) {
      return find(assinatura.usuarios, ['email', user.info.email]);
    } else {
      return {};
    }
  }

  getHeaderTooltip(header) {
    const { classes } = this.props;

    return (
      <Tooltip
        classes={{ popper: classes.lightTooltipPopper, tooltip: classes.lightTooltip }}
        placement="top"
        title="Admin pode convidar, remover ou dar privilégio de admin para outros usuários da assinatura."
      >
        <span className={classes.tooltipContentWrapper}>
          {header} <InfoIcon />
        </span>
      </Tooltip>
    );
  }

  getTableData() {
    const { assinatura } = this.state;
    const currentUser = this.getCurrentUser();
    const shouldShow = this.shouldShow(currentUser);

    if (!assinatura) return [];

    const getBadge = pendente => {
      return pendente ? (
        <Badge color="warning">Pendente</Badge>
      ) : (
        <Badge color="success">Ativo</Badge>
      );
    };

    // Não podemos usar _.compact aqui porque sobrenome as vezes é "".
    return map(assinatura.usuarios, usuario => filter([
      usuario.nome,
      usuario.sobrenome,
      usuario.email,
      shouldShow && getBadge(usuario.pendente),
      shouldShow && this.getAdminSelect(usuario),
      shouldShow && this.getButton(usuario),
    ], value => value !== false));
  }

  handleConvidarClick = params => {
    const { assinatura } = this.state;

    return addUserAssinatura(params)
      .then(({ data }) => {
        this.props.showAlert({ message: `${params.email} convidado com sucesso.`, type: 'success' });
        this.setState({
          assinatura: {
            ...assinatura,
            usuarios: [...assinatura.usuarios, data],
          },
        });
      })
      .catch(({ response }) => {
        this.props.showAlert({ message: values(response.data).join(' '), type: 'error' });
      });
  }

  handleIsAdminChange(usuarioAlterado, isAdmin) {
    const { assinatura } = this.state;
    const params = { admin: isAdmin, email: usuarioAlterado.email };

    this.setState({ adminUserChanging: usuarioAlterado.id });

    updateUserAssinatura(params)
      .then(({ data }) => {
        const message = isAdmin ? `${usuarioAlterado.email} se tornou admin da assinatura.` : `${usuarioAlterado.email} não é mais admin da assinatura.`;
        this.props.showAlert({ message, type: 'success' });
        this.setState({
          adminUserChanging: null,
          assinatura: {
            ...assinatura,
            usuarios: map(assinatura.usuarios, usuario => usuario.email !== usuarioAlterado.email ? usuario : data),
          },
        });
      })
      .catch(() => {
        this.props.showAlert({ message: 'Ocorreu um erro, por favor tente após alguns minutos.', type: 'error' });
        this.setState({ adminUserChanging: null });
      });
  }

  handleRemoveUserClick = usuario => {
    const { assinatura } = this.state;

    this.setState({ removingUser: usuario.id });

    removeUserAssinatura(usuario.id)
      .then(() => {
        this.props.showAlert({ message: `${usuario.email} removido com sucesso.`, type: 'success' });
        this.setState({
          assinatura: {
            ...assinatura,
            usuarios: filter(assinatura.usuarios, u => u.email !== usuario.email),
          },
          removingUser: null,
        });
      })
      .catch(({ response }) => {
        this.props.showAlert({ message: values(response.data).join(' '), type: 'error' });
        this.setState({ removingUser: null });
      });
  }

  shouldShow(currentUser) {
    return currentUser.admin && this.state.assinatura.numeroMaximoUsuarios > 1;
  }

  render() {
    const { classes } = this.props;
    const { assinatura } = this.state;
    const currentUser = this.getCurrentUser();
    const shouldShow = this.shouldShow(currentUser);

    if (!assinatura) return false;

    return (
      <div>
        <GridContainer>
          <GridItem md={12} sm={12} xs={12}>
            <ECCard
              content={
                <div>
                  <Table
                    customCellClasses={[classes.center]}
                    customClassesForCells={[5]}
                    customHeadCellClasses={[classes.center]}
                    customHeadClassesForCells={[5]}
                    tableData={this.getTableData()}
                    tableHead={compact([
                      "Nome",
                      "Sobrenome",
                      "Email",
                      shouldShow && "Status",
                      shouldShow && this.getHeaderTooltip("Admin"),
                      shouldShow && "Ações",
                    ])}
                  />
                </div>
              }
              icon={<People />}
              iconColor="info"
              title={<span title={assinatura.nome}>Assinatura {truncate(assinatura.nome)} - Expira em {moment(assinatura.dataExpiracao).format("DD/MM/YY")}</span>}
            />
          </GridItem>
        </GridContainer>
        {this.shouldShow(currentUser) && (
          <ConvidarUsuario assinatura={assinatura} handleClick={this.handleConvidarClick} />
        )}
      </div>
    );
  }
}

Assinatura.propTypes = {
  classes: PropTypes.object.isRequired,
  showAlert: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = {
  showAlert,
};

export { Assinatura as AssinaturaComponent };
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Assinatura));



// WEBPACK FOOTER //
// ./src/views/Assinatura/Assinatura.jsx